import { colors, COLORS } from '@constants/colors';

export const useLocalizationStyles = () => ({
  scopeTag: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '10px',
    fontWeight: 700,
    letterSpacing: '0.05em',
    padding: '3px 8px',
    borderRadius: '6px',
    textTransform: 'uppercase',
    backgroundColor: 'rgba(255, 255, 255, 0.07)',
    color: colors.white_60,
  },
  scopeTagRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    flexWrap: 'wrap',
  },
  activeLangHint: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '10px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    padding: '3px 8px',
    borderRadius: '6px',
    textTransform: 'uppercase',
    backgroundColor: 'rgba(255, 184, 0, 0.12)',
    color: '#FFB800',
    border: '1px solid rgba(255, 184, 0, 0.28)',
  },
  langCodeActive: {
    backgroundColor: 'rgba(76, 203, 160, 0.18)',
    border: '1px solid rgba(76, 203, 160, 0.55)',
    color: '#4CCBA0',
  },
  activeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '9.5px',
    fontWeight: 700,
    letterSpacing: '0.05em',
    padding: '2px 6px',
    borderRadius: '5px',
    textTransform: 'uppercase',
    backgroundColor: 'rgba(76, 203, 160, 0.14)',
    color: '#4CCBA0',
    border: '1px solid rgba(76, 203, 160, 0.4)',
    flexShrink: 0,
  },

  card: {
    marginTop: '8px',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.025)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    padding: '10px 12px',
    cursor: 'pointer',
    userSelect: 'none',
  },
  headerIcon: {
    width: 16,
    height: 16,
    color: colors.white_60,
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: COLORS.WHITE,
  },
  badge: {
    fontSize: '10px',
    fontWeight: 700,
    color: colors.white_60,
    backgroundColor: 'rgba(255, 255, 255, 0.07)',
    borderRadius: '99px',
    padding: '1px 7px',
    minWidth: 18,
    textAlign: 'center',
  },
  badgeZero: {
    color: colors.white_40,
  },
  codes: {
    flex: 1,
    minWidth: 0,
    fontSize: '10.5px',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    color: colors.white_40,
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'uppercase',
  },
  chev: {
    marginLeft: 'auto',
    color: colors.white_60,
    transition: 'transform 0.2s ease',
    width: 14,
    height: 14,
    flexShrink: 0,
  },
  chevCollapsed: {
    transform: 'rotate(-90deg)',
  },

  body: {
    padding: '0 12px 12px',
    display: 'flex',
    flexDirection: 'column',
  },
  empty: {
    fontSize: '12px',
    color: colors.white_60,
    lineHeight: 1.5,
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    border: '1px dashed rgba(255, 255, 255, 0.12)',
    borderRadius: '10px',
    padding: '12px',
    marginBottom: '10px',
  },
  emptyStrong: {
    display: 'inline',
    color: COLORS.WHITE,
    fontWeight: 600,
  },

  imageRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 0',
    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    '&:first-of-type': {
      borderTop: 0,
    },
  },
  langCode: {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    fontSize: '10px',
    fontWeight: 700,
    letterSpacing: '0.05em',
    color: COLORS.WHITE,
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '5px',
    width: 28,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    textTransform: 'uppercase',
  },
  langName: {
    flexShrink: 0,
    width: 72,
    fontSize: '12px',
    fontWeight: 500,
    color: COLORS.WHITE,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  fileInfo: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  filename: {
    fontSize: '11.5px',
    color: colors.white_60,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  filenamePending: {
    color: '#FFB800',
  },
  thumbXs: {
    width: 28,
    height: 28,
    borderRadius: '6px',
    flexShrink: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white_40,
    position: 'relative',
    overflow: 'hidden',
  },
  thumbSm: {
    width: 36,
    height: 36,
    borderRadius: '8px',
    flexShrink: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: colors.white_40,
    position: 'relative',
    overflow: 'hidden',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
  },
  iconButton: {
    width: 28,
    height: 28,
    borderRadius: '6px',
    border: '1px solid rgba(255, 255, 255, 0.14)',
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    color: COLORS.WHITE,
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.28)',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.32)',
      borderColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  iconButtonDanger: {
    '&:hover': {
      borderColor: '#FF6B6B',
      color: '#FF6B6B',
      backgroundColor: 'rgba(255, 107, 107, 0.06)',
    },
  },
  miniUpload: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    color: COLORS.WHITE,
    textTransform: 'none',
    fontSize: '11px',
    fontWeight: 600,
    padding: '5px 9px',
    borderRadius: '7px',
    minWidth: 0,
    whiteSpace: 'nowrap',
    boxShadow: 'none',
    '&:hover': { backgroundColor: '#3A46C1', boxShadow: 'none' },
  },

  videoCard: {
    padding: '10px 0',
    borderTop: '1px solid rgba(255, 255, 255, 0.06)',
    '&:first-of-type': {
      borderTop: 0,
    },
  },
  videoCardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '8px',
  },
  videoCardLine: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '4px 0',
  },
  videoCardMeta: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  videoCardTitle: {
    fontSize: '11.5px',
    fontWeight: 600,
    color: COLORS.WHITE,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  videoCardStatus: {
    fontSize: '10.5px',
    color: colors.white_50,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  statusOk: {
    color: '#4CCBA0',
  },
  statusWarn: {
    color: '#FFB800',
  },
  statusError: {
    color: '#FF6B6B',
  },
  conversionBar: {
    marginTop: '4px',
    height: 3,
    borderRadius: '99px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '& .MuiLinearProgress-bar': {
      borderRadius: '99px',
      backgroundColor: '#FFB800',
    },
  },
  playBadge: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.32)',
    color: COLORS.WHITE,
    pointerEvents: 'none',
  },

  addButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '7px',
    width: '100%',
    marginTop: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    color: COLORS.WHITE,
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 500,
    padding: '9px',
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.07)',
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.4)',
      borderColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  addButtonRemaining: {
    color: colors.white_40,
    fontWeight: 500,
    marginLeft: '2px',
  },
  popoverPaper: {
    backgroundColor: 'rgba(22, 24, 32, 0.98)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    minWidth: 240,
    boxShadow: '0 18px 50px rgba(0, 0, 0, 0.5)',
  },
  popoverSearch: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
  },
  popoverSearchIcon: {
    color: colors.white_40,
    fontSize: 16,
  },
  popoverSearchInput: {
    flex: 1,
    '& input': {
      padding: 0,
      fontSize: '12px',
      color: COLORS.WHITE,
      '&::placeholder': {
        color: colors.white_40,
        opacity: 1,
      },
    },
    '& fieldset': { display: 'none' },
  },
  popoverList: {
    maxHeight: 220,
    overflowY: 'auto',
    padding: '6px',
  },
  popoverItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '7px 8px',
    borderRadius: '7px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
    },
  },
  popoverItemDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    border: '1.5px solid rgba(255, 255, 255, 0.22)',
    flexShrink: 0,
  },
  popoverItemName: {
    flex: 1,
    fontSize: '12.5px',
    fontWeight: 500,
    color: COLORS.WHITE,
  },
  popoverItemCode: {
    fontSize: '10.5px',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    color: colors.white_40,
    textTransform: 'uppercase',
  },
  popoverEmpty: {
    padding: '14px',
    textAlign: 'center',
    fontSize: '12px',
    color: colors.white_40,
  },
});
